import { createBrowserHistory } from 'history';
import { connectGaToHistory } from '@au/core/lib/utils/ga';

export const history = connectGaToHistory(createBrowserHistory());
